import { useLang } from 'hooks/lang';

import { loaders, useProjectTeamChangeResponse } from 'entities';

import { Button, Column, Row, Skeleton } from 'components/Blocks';
import { UserAvatar } from 'components/UserAvatar';
import { CircleXIcon, DoubleCheckIcon } from 'components/Icons';

import { useProjectProfile } from '../../context';

export function ReviewTeamChangeRequest() {
  const { t } = useLang();
  const { project, projectModalConfig, updateProject } = useProjectProfile();

  const { data } = loaders.projects.getTeamChangeRequest.use({
    params: {
      projectId: project?.id,
      requestId: project?.teamChangeRequest?.id as string,
    },
  });

  const mutations = useProjectTeamChangeResponse({
    project,

    onFinish: projectModalConfig.closeModal,

    onReject: () =>
      updateProject((old) => ({
        ...old,
        teamChangeRequest: null,
      })),

    onAccept: (newOwner) =>
      updateProject((old) => ({
        ...old,
        teamChangeRequest: null,
        owner: newOwner!,
        teamResponsible: newOwner!.team,
      })),
  });

  if (!data) return <Skeleton height={100} />;

  return (
    <Column gap="6">
      <Row className="font-semibold" gap="2">
        <UserAvatar user={data.requestedBy} size={36} />

        {t('request-comments')}
      </Row>

      <Column className="rounded-lg border bg-muted p-2">
        {data.justification
          .split('\n')
          .filter(Boolean)
          .map((text) => (
            <p key={text}>
              {text}
              <br />
            </p>
          ))}
      </Column>

      <Row justifyContent="space-between">
        <Button
          variant="outlined"
          color="destructive"
          onClick={mutations.rejectRequest}
          loading={mutations.loading}
        >
          <CircleXIcon />
          {t('reject')}
        </Button>

        <Button
          variant="outlined"
          color="success"
          onClick={mutations.acceptRequest}
          loading={mutations.loading}
        >
          <DoubleCheckIcon />
          {t('accept')}
        </Button>
      </Row>
    </Column>
  );
}
